import {Button, Card, CardBody, CardText, CardTitle, ListGroup, ListGroupItem, Modal, ModalBody, ModalFooter, ModalHeader} from "inferno-bootstrap";
import {T} from "inferno-i18next";
import {renderAttachment} from "../../views/chat/transcript/message/AttachmentBody";
import {formatSize} from "../../utils/util";
import Error from "inferno-feather/dist/icons/x-circle";
import {Bundle} from "../../services/translationProvider";
import {Deferred} from "@sap/cpaas-commlib-lib";
import {Level} from "../../utils/types";
import {IFile} from "./MediaDrop";

export type Props = { deferred: Deferred, files: IFile[], sizeLimit: string };
export const FilePreview = (props: Props) => {
	return (
		<Modal className="file-preview" isOpen={true}>
			<ModalHeader><T i18nKey="VCC_XTIT_ATTACH_TITLE">x</T></ModalHeader>
			<ModalBody>
				<ListGroup>
					{props.files.map((item) => (
						<ListGroupItem key={item.name} disabled={item.valid}>
							{!item.valid && (
								<Card className="p-0 border-0">
									<CardBody>
										<CardTitle><Error className="text-danger mr-2 d-inline"/>{item.name}</CardTitle>
										<CardText>{item.validMime === false ? Bundle.t("VCC_XMSG_ITEM_MIME_INVALID") : Bundle.t("VCC_XMSG_ITEM_SIZE_INVALID") + " " + props.sizeLimit}</CardText>
									</CardBody>
								</Card>
							)}
							{item.valid && renderAttachment(item.type, item.name, item.url, formatSize(item.size))}
						</ListGroupItem>
					))}
				</ListGroup>
			</ModalBody>
			<ModalFooter>
				<Button outline color={Level.Primary} onClick={() => props.deferred.res(true)}>
					<T i18nKey="VCC_XBUT_BTN_OK">x</T>
				</Button>
				<Button outline color={Level.Secondary} onClick={() => props.deferred.res(false)}>
					<T i18nKey="VCC_XBUT_BTN_CANCEL">x</T>
				</Button>
			</ModalFooter>
		</Modal>
	);
};
